import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Camera" size={48} color="#D4AF37" strokeWidth={1.5} />
          </div>
          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-primary mb-4">Page Not Found</h2>
          <p className="text-text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved to a new location.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/homepage-cinematic-gateway"
            className="inline-flex items-center justify-center space-x-2 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-semibold cinematic-transition cta-glow hover:shadow-elevation w-full"
          >
            <Icon name="Home" size={20} strokeWidth={2} />
            <span>Return Home</span>
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center space-x-2 border-2 border-border text-text-primary hover:bg-surface px-8 py-4 rounded-lg font-semibold cinematic-transition w-full"
          >
            <Icon name="ArrowLeft" size={20} strokeWidth={2} />
            <span>Go Back</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;